import React from "react";
import { ResumenPorHabitacion } from "../EstadisticasHotel";

interface Props {
    habitaciones: ResumenPorHabitacion[];
    isOpen: boolean;
    onClose: () => void;
}

export const HabitacionesMotivosPerdidaList: React.FC<Props> = ({
    habitaciones,
    isOpen,
    onClose,
}) => {
    if (!isOpen) return null;

    const conPerdidas = habitaciones.filter((h) => {
        const motivos = h.motivos_perdida;
        return Object.values(motivos).some((m) => m.count > 0);
    });

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-11/12 p-6 bg-white rounded-lg shadow-lg md:w-8/12 lg:w-6/12 max-h-[80vh] overflow-y-auto">
                {/* Botón cerrar */}
                <button
                    onClick={onClose}
                    className="absolute text-gray-600 top-3 right-3 hover:text-gray-800"
                    aria-label="Cerrar modal">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>

                <h2 className="mb-4 text-xl font-semibold text-center">
                    Motivos de Pérdida por Habitación
                </h2>

                {conPerdidas.length === 0 ? (
                    <p className="py-4 text-center text-gray-600">
                        No hay motivos de pérdida para mostrar este mes.
                    </p>
                ) : (
                    <div className="grid grid-cols-1 gap-6">
                        {conPerdidas.map((h) => (
                            <div key={h.id} className="p-4 border rounded">
                                <div className="flex items-center mb-3">
                                    <img
                                        src={`${process.env.REACT_APP_PROXY}/hotel_habitaciones/getImage/${h.habitacion.banner}`}
                                        alt={h.habitacion.nombre}
                                        className="object-cover w-16 h-16 mr-4 rounded"
                                    />
                                    <p className="text-lg font-medium">
                                        {h.habitacion.nombre}
                                    </p>
                                </div>
                                <ul className="space-y-1 text-sm text-gray-700">
                                    {Object.entries(h.motivos_perdida).map(
                                        ([clave, motivo]) =>
                                            motivo.count > 0 && (
                                                <li key={clave}>
                                                    <strong>
                                                        {clave.replace(
                                                            /_/g,
                                                            " "
                                                        )}
                                                        :
                                                    </strong>{" "}
                                                    {motivo.count} (
                                                    {motivo.porcentaje}%)
                                                </li>
                                            )
                                    )}
                                </ul>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
